'use strict';

import './TextAreaInput.less';

import React from 'react';
import PropTypes from 'prop-types';
import Input from './Input';

export default class TextAreaInput extends React.Component {
	constructor(props) {
		super(props);

		this.state = {
			height: 65
		};
	}

	componentWillReceiveProps(nextProps) {
		if (this.props.value !== nextProps.value) {
			this.handleChange(nextProps.value);
		}
	}

	componentDidMount() {
		if (this.props.value) {
			this.handleChange(this.props.value);
		}
	}

	checkForResize() {
		if (this.self.scrollHeight > this.self.clientHeight) {
			this.setState({
				height: this.self.scrollHeight
			});
		}
	}

	handleChange(value) {
		this.checkForResize();

		this.props.onChange.call(this, value);
	}

	render() {
		return (
			<Input {...this.props} className="TextAreaInput">
				<textarea
					className={this.props.noborder ? 'TextAreaInput--no-border' : ''}
					placeholder={this.props.placeholder}
					name={this.props.name}
					value={this.props.value}
					ref={c => (this.self = c)}
					disabled={this.props.disabled}
					onChange={event => {
						const { target } = event;
						let { value } = target;

						this.handleChange(value);
					}}
					style={{ height: this.state.height }}
				/>
			</Input>
		);
	}
}

TextAreaInput.defaultProps = {
	value: '',
	optional: false
};

TextAreaInput.propTypes = {
	name: PropTypes.string.isRequired,
	value: PropTypes.string,
	disabled: PropTypes.bool,
	placeholder: PropTypes.string,
	onChange: PropTypes.func,
	optional: PropTypes.bool,
	noborder: PropTypes.bool
};
